export default __webpack_public_path__ + "static/media/hippy-crasher-sweet.28732875.png";